import extendReducer from "@cirrus/legacy/app-common/alt/framework/extendReducer/extendReducer.es6"

export default ({ actions }) =>
  (reducer) =>
    extendReducer(
      {
        [actions.reset]: (state, payload) => reducer(),
      },
      false,
    )(reducer)
